// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-zzj","colBig":"styles_colBig__15mQc","colSmall":"styles_colSmall__3qsfl","shopifyNameWrapper":"styles_shopifyNameWrapper__1cZ39"};